// @flow
export { default } from './EstimateTemplate';



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateTemplate/index.js